import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import ClientSeatsTab from "./tabs/client-seats.tab";
import { getUserClients, getUserStateActiveClient } from "src/redux/user/user.selectors";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setUserStateActiveClient } from "src/redux/user/user.slice";
import { getUrlForPage } from "src/components/form/update-profile-form/dashboard-access-modal";

const ClientSeats = () => {
  useSetPageTitle('Client Seats');
  const clients = useSelector(getUserClients);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeClient = useSelector(getUserStateActiveClient);

  useEffect(() => {
    // 1. If user only has one client, skip seats, auto-activate and route
    if (clients?.length === 1) {
      dispatch(setUserStateActiveClient(clients[0]));
      // Dashboard access check for single client
      const client = clients[0];
      const hasDashAccess =
        client?.permissions?.some((perm: any) => perm.page && perm.page !== 'reports');

      if (hasDashAccess) {
        navigate(`/client/${client.ext_client_id}/${getUrlForPage(client?.permissions[0].page) ?? 'reports-old'}`, { replace: true });
      } else {
        navigate(`/client/${client.ext_client_id}/reports-old`, { replace: true });
      }
      return;
    }

    // 2. If there is an activeClient, check if they have dashboard access
    if (activeClient) {
      const filteredPermissions = activeClient?.permissions?.filter((perm: any) => perm.page && perm.page !== 'reporting');
      if (filteredPermissions.length > 0) {
        navigate(`/client/${activeClient.ext_client_id}/${getUrlForPage(filteredPermissions[0].page) ?? 'reports-old'}`, { replace: true });
      } else {
        navigate(`/client/${activeClient.ext_client_id}/reports-old`, { replace: true });
      }
      return;
    }
  }, [clients, activeClient]);

  return (
    <AppLayout
      activePage="/client/seats"
      navbarProps={{
        tabs: [],
        activeTab: '',
        onTabChange: () => {},
      }}
    >
      <div className="space-y-6">
        <ClientSeatsTab />
      </div>
    </AppLayout>
  );
};

export default ClientSeats;
